const actionTypes = {
  SET_STATUS: '@WS/SAVING/SET_STATUS',
  SET_ERROR: '@WS/SAVING/SET_ERROR',
};

export default actionTypes;
